module.exports = __webpack_public_path__ + "static/media/TheCollage.83a3b298.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/img/personalProject/TheCollage.mp4
// module id = 188
// module chunks = 0